import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const AnimatedText = ({ htmlContent, customClass }) => {
  const textRef = useRef();

  useEffect(() => {
    const text = textRef.current;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    
    // Save the original content
    const originalContent = [...tempDiv.childNodes];
    text.innerHTML = '';
    
    let charCount = 0;
    const elementsToAnimate = [];
    
    // Process each node in the content
    originalContent.forEach((node, nodeIndex) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // Handle text nodes
        const textContent = node.textContent;
        textContent.split('').forEach((char, charIndex) => {
          const span = document.createElement('span');
          span.textContent = char;
          span.classList.add(`${customClass}-letter`, `${customClass}-letter-${charCount + 1}`);
          text.appendChild(span);
          elementsToAnimate.push(span);
          charCount++;
        });
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        // Handle <br> tags
        text.appendChild(node.cloneNode());
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Handle other HTML elements (like spans, strong, em, etc.)
        const element = node.cloneNode();
        const innerText = node.textContent;
        
        innerText.split('').forEach((char, charIndex) => {
          const span = document.createElement('span');
          span.textContent = char;
          span.classList.add(`${customClass}-letter`, `${customClass}-letter-${charCount + 1}`);
          element.appendChild(span);
          elementsToAnimate.push(span);
          charCount++;
        });
        
        text.appendChild(element);
      }
    });

    // Animate the text
    gsap.from(elementsToAnimate, {
      opacity: 0.04,
      y: 50,
      duration: 0.3,
      stagger: 0.04,
      scrollTrigger: {
        trigger: text,
        start: 'top 80%',
        end: 'top 20%',
        toggleActions: 'play none none reverse',
      },
      onComplete: () => {
        elementsToAnimate.forEach(span => {
          if (span.style.opacity === '1') {
            span.classList.add(`${customClass}-letter-opacity-1`);
          }
        });
      },
    });
  }, [customClass, htmlContent]);

  return (
    <div ref={textRef} className={customClass} dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default AnimatedText;
